'use strict';

bbw.directive.bbwClickScroll = ['$document', function($document) {
    var MAX_ITERS = 30;
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            var scrollPos = parseInt(scope.$eval(attrs.bbwClickScroll));
            if (isNaN(scrollPos)) {
                scrollPos = 0;
            }
            var isScrolling = false, scroll = function scroll(to, timeout, iters) {
                if (angular.isUndefined(iters)) {
                    iters = 0;
                }
                if (++iters > MAX_ITERS) {
                    return;
                }
                isScrolling = true;
                var currentTop = $document[0].documentElement.scrollTop;
                var diff = currentTop - to;
                if (diff < 10) {
                    if (diff) {
                        window.scrollTo(0, to);
                    }
                    isScrolling = false;
                } else {
                    var steps = Math.round(diff / 10);
                    var stepTime = Math.round(timeout / steps);
                    if (stepTime > 50) {
                        stepTime = 50;
                    }
                    window.scrollBy(0, -steps);
                    setTimeout(
                        scroll.bind(null, to, timeout *.7, iters),
                        stepTime
                    );
                }
            };
            element.on('mouseup', function() {
                if (!isScrolling) {
                    if (scrollPos == -1) {
                        window.scrollTo(0, 0);
                    } else {
                        scroll(scrollPos, 500);
                    }
                }
            });
        }
    };
}];
